<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { periodicTasksMethods } from '@state/helpers'
import PeriodicTasksForm from '@views/scheduled_tasks/periodic_tasks/form'
import PeriodicTasksDelete from '@components/scheduled-tasks/periodic-tasks/delete'
import PeriodicTasksManualExecution from '@components/scheduled-tasks/periodic-tasks/manual-execution'


var colors = {
  hex: '#194d33',
  a: 1,
}

export default {
  page: {
    title: 'Scheduled tasks/Tasks',
    meta: [{ name: 'description', content: 'Scheduled tasks/Tasks' }],
  },
  components: { 
    Layout, PageHeader, BaseDatatable, 
    PeriodicTasksForm, PeriodicTasksDelete,
    PeriodicTasksManualExecution },
  data() {
    return {
      title: 'Scheduled tasks/Tasks',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Scheduled tasks/Tasks',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'name', label: 'Nombre' },
        { key: 'task', label: 'Tarea' },
        { key: 'execution_type', label: 'Tipo de ejecución' },
        { key: 'enabled', align: 'center', label: '¿Habilitada?' },
        // { key: 'start_time', label: 'Fecha de inicio' },
        { key: 'last_run_at', label: 'Última ejecución' },
        { key: 'one_off', label: this.$t('ejecutar-unica-vez') },
        { key: 'actions', label: this.$t('basic.actions') },
      ],
      action: '',

      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      showManualExecution : false,
      toManualExecution : {},
      toUpdate : {},
      toDelete: {},
      showForm: false,
      showDelete: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
    }
  },

  methods: {
    ...periodicTasksMethods,

    myProvider(ctx) {
      const promise = this.fetchPeriodicTasks(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          console.log(error)
          return []
        })
    },

    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Tarea: ${item.name}`
      const promise = context.fetchPeriodicTasksDetail(item.url)
      return promise
        .then((data) => {
          context.detailModal.content = data
          context.detailModalShow = !context.detailModalShow
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
    },

    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },

    openDeleteModal(item, index) {
      this.toDelete = item
      this.showDelete = true
    },


    openCreateUpdateModal(item, row) {
      let context = this
      if (item) {
        context.toUpdate = item
      } else {
        context.toUpdate = {}
      }
      context.showForm = true
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card>
            <b-button
              variant="primary"
              size="sm"
              @click="openCreateUpdateModal(null, null)"
            >
              <i class="fad fa-plus"></i> Crear
            </b-button>

            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:cell(task)="row">
                {{ row.item.task_name_verbose }}
              </template>
              <template v-slot:cell(execution_type)="row">
                <span v-if="row.item.clocked"> Fecha programada </span>
                <span v-if="row.item.interval"> Intervalo </span>
                <span v-if="row.item.crontab"> Crontab </span>
              </template>
              <template v-slot:cell(enabled)="row">
                <span
                  v-if="row.value"
                  class="fad fa-circle-check text-success"
                ></span>
                <span v-else class="fad fa-circle-xmark text-danger"></span>
              </template>
              <template v-slot:cell(one_off)="row">
                <span
                  v-if="row.value"
                  class="fad fa-circle-check text-success"
                ></span>
                <span v-else class="fad fa-circle-xmark text-danger"></span>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`manual-execution-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'success',
                      placement: 'leftbottom',
                      title: 'Ejecutar manualmente',
                    }"
                    variant="btn-link text-success btn-transparent"
                    size="xs"
                    @click="
                      toManualExecution = { url: row.item.url };
                      showManualExecution = true
                    "
                  >
                    <i class="fad fa-play fe-2x"></i>
                  </b-button>
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: 'Detalle',
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    :disabled="
                      isSubmitting || actionsLoadings[`info-btn-${row.index}`]
                    "
                    @click="
                      openDetailModal(
                        row.item,
                        row.index,
                        `info-btn-${row.index}`
                      )
                    "
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fad fa-circle-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('basic.edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="openCreateUpdateModal(row.item, row.index)"
                  >
                    <i class="fad fa-pen fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: 'Eliminar',
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fad fa-trash-xmark"></i>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <b-modal
      :id="detailModal ? detailModal.id : 'detail-modal'"
      v-model="detailModalShow"
      ok-only
      size="lg"
      :title="detailModal ? detailModal.title : ''"
      @hide="resetdetailModal"
    >
      <!--{{ detailModal.content }}-->
      <b-container v-if="detailModal" fluid>
        <b-row>
          <b-col md="12">
            <table
              v-if="detailModal.content.id"
              class="table-hover table-sm mb-0 table-responsive"
              style="table-layout: fixed; width: 100%"
            >
              <tr
                ><th style="text-align: right">Name </th
                ><td>{{ detailModal.content.name }} </td></tr
              >
              <tr
                ><th style="text-align: right">Tarea </th
                ><td>{{ detailModal.content.task }} </td></tr
              >
              <tr
                ><th style="text-align: right">Intervalo </th
                ><td>{{ detailModal.content.interval }} </td></tr
              >
              <tr
                ><th style="text-align: right">Crontab </th
                ><td>{{ detailModal.content.crontab }} </td></tr
              >
              <tr
                ><th style="text-align: right">Calendario solar </th
                ><td>{{ detailModal.content.solar }} </td></tr
              >
              <tr
                ><th style="text-align: right">Hora programado </th
                ><td>{{ detailModal.content.clocked }} </td></tr
              >
              <tr
                ><th style="text-align: right">args </th
                ><td>{{ detailModal.content.args }} </td></tr
              >
              <tr
                ><th style="text-align: right">kwargs </th
                ><td>{{ detailModal.content.kwargs }} </td></tr
              >
              <tr
                ><th style="text-align: right">queue </th
                ><td>{{ detailModal.content.queue }} </td></tr
              >
              <tr
                ><th style="text-align: right">exchange </th
                ><td>{{ detailModal.content.exchange }} </td></tr
              >
              <tr
                ><th style="text-align: right">routing_key </th
                ><td>{{ detailModal.content.routing_key }} </td></tr
              >
              <tr
                ><th style="text-align: right">headers </th
                ><td>{{ detailModal.content.headers }} </td></tr
              >
              <tr
                ><th style="text-align: right">priority </th
                ><td>{{ detailModal.content.priority }} </td></tr
              >
              <tr
                ><th style="text-align: right">expires </th
                ><td>{{ detailModal.content.expires }} </td></tr
              >
              <tr
                ><th style="text-align: right">expire_seconds </th
                ><td>{{ detailModal.content.expire_seconds }} </td></tr
              >
              <tr
                ><th style="text-align: right">one_off </th
                ><td>{{ detailModal.content.one_off }} </td></tr
              >
              <tr
                ><th style="text-align: right">start_time </th
                ><td>{{ detailModal.content.start_time }} </td></tr
              >
              <tr
                ><th style="text-align: right">enabled </th
                ><td>{{ detailModal.content.enabled }} </td></tr
              >
              <tr
                ><th style="text-align: right">description </th
                ><td>{{ detailModal.content.description }} </td></tr
              >
            </table>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <PeriodicTasksForm
      v-if="showForm"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showForm = false;
          toUpdate = {}
        }
      "
    >
    </PeriodicTasksForm>

    <PeriodicTasksDelete
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {}
        }
      "
    >
    </PeriodicTasksDelete>

    <PeriodicTasksManualExecution
      v-if="showManualExecution"
      :instanceJson="toManualExecution"
      :oncomplete="
        () => {
          showManualExecution = false;
          toManualExecution = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showManualExecution = false;
          toManualExecution = {}
        }
      "
    >
    </PeriodicTasksManualExecution>
  </Layout>
</template>
